/* eslint-disable */
/*********************************************************
/ Glorious generated code by DoneDone's Code Generator.
/ Written by Ka Wai Cheung.
/ Don't modify this by hand silly!
*********************************************************/

import { RequestHandler } from '../request-handler'
import {
  ICompaniesInputCreate,
  ICompaniesInputCreateAccountMembership,
} from '../types/request.types'
import {
  ICompanyRoster,
  IGenericJSONMessage,
  IPostSuccess,
} from '../types/response.types'

export default new class CompaniesAPI extends RequestHandler {
  /****** GET methods *****/
  public async get_Rosters(
  ): Promise<ICompanyRoster[]> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/companies/rosters`,
    })
  }
  public async get_GuestsRosters(
  ): Promise<ICompanyRoster[]> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/companies/guests-rosters`,
    })
  }
  public async get_Roster(
    company_id: any,
  ): Promise<ICompanyRoster> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/companies/${company_id}/roster`,
    })
  }
  public async get_GuestsRoster(
    company_id: any,
  ): Promise<ICompanyRoster> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/companies/${company_id}/guests-roster`,
    })
  }
  public async get_BulkRegistrationInvitation(
  ): Promise<IGenericJSONMessage> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/companies/bulk-registration-invitation`,
    })
  }
  public async get_BulkGuestsInvitation(
  ): Promise<IGenericJSONMessage> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/companies/bulk-guests-invitation`,
    })
  }
  /****** POST methods *****/
  public async post_Create(
    data: ICompaniesInputCreate,
  ): Promise<IPostSuccess> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/companies`,
      data,
    })
  }
  public async post_CreateAccountMembership(
    company_id: any,
    data: ICompaniesInputCreateAccountMembership,
  ): Promise<IPostSuccess> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/companies/${company_id}/account-membership`,
      data,
    })
  }
  /****** PUT methods *****/
  public async put_UpdateName(
    company_id: any,
    name: string,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/companies/${company_id}/name`,
      data: {
        name
      },
    })
  }
  /****** DELETE methods *****/
  public async delete_Delete(
    company_id: any,
  ): Promise<IGenericJSONMessage> {
    return await this.delete({
      url: `/[[ACCOUNT_ID]]/companies/${company_id}`,
    })
  }
}()
